import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subject } from "rxjs";

import { AuthServices } from "./auth.service";
import { Injectable } from "@angular/core";
import { endpoints } from "../_config/url-endpoint";
import { convertObjectToQueryParams } from "../util/convertObjectToQueryParams";

@Injectable({
  providedIn: "root",
})
export class PartnerService {
  private savePartnerVal = new Subject<any>();

  constructor(private http: HttpClient, private authService: AuthServices) {}

  createPartner(body): Observable<any> {
    return this.http.post(endpoints.partnerPage.createPartner, body);
  }

  changePartnerStatus(partnerId, body): Observable<any> {
    return this.http.post(endpoints.partnerPage.changePartnerStatus + partnerId, body);
  }
   actionPartnerStatus(body): Observable<any> {
    return this.http.post(endpoints.partnerPage.actionUrl , body);
  }

  // editPartner(partnerId, body): Observable<any> {
  //   return this.http.put(endpoints.partnerPage.editPartner + partnerId, body);
  // }
  editPartner(body): Observable<any> {
    return this.http.post(endpoints.partnerPage.editPartner, body, this.authService.getAccessHeaders());
  }
  // getPartnerDetails(partnerId): Observable<any> {
  //     return this.http.get(endpoints.partnerPage.getPartnerDetails + partnerId, this.authService.getAccessHeaders());
  // }
  getPartnerDetails(partnerId): Observable<any> {
    return this.http.get(
      endpoints.partnerPage.getPartnersDetailAnalytics + partnerId,
      this.authService.getAccessHeaders(),
    );
  }

  getPartner(): Observable<any> {
    return this.http.get(endpoints.partnerPage.getPartner, this.authService.getAccessHeaders());
  }

  // getPartners(queryString): Observable<any> {
  //     let url = `${endpoints.partnerPage.getPartners}?${queryString}`;
  //     return this.http.get(url, this.authService.getAccessHeaders());
  // }
  /** Fetch partner list using analytics endpoint, including partnerType */
  //  getPartners(queryString: string): Observable<any> {
  //     const url = `${endpoints.partnerPage.getPartnersAnalytics}new?${queryString}`;
  //     return this.http.get(url, this.authService.getAccessHeaders());
  // }
      getPartners(queryString: string, type: "new" | "registration"): Observable<any> {
        // Remove the type parameter from queryString for both onboarding and registration
        let cleanQueryString = queryString;
        cleanQueryString = queryString.replace(/[?&]type=ONBOARDING/g, '').replace(/[?&]type=onboarding/g, '');
        cleanQueryString = cleanQueryString.replace(/[?&]type=REGISTERED/g, '').replace(/[?&]type=registered/g, '');
        
        const url = `${endpoints.partnerPage.getPartnersAnalytics}${type}?${cleanQueryString}`;
        return this.http.get(url, this.authService.getAccessHeaders());
    }

  getPartnerCount(type: "new" | "registration", tenantId?: string): Observable<any> {
    const endpointType = type === "new" ? "onboarding" : "registration";
    const url = `${endpoints.partnerPage.getPartnersAnalyticsCountUrl}/totalcount/${endpointType}?tenantId=${tenantId}`;
    return this.http.get(url, this.authService.getAccessHeaders());
  }
  downloadFile(queryString, type?: "new" | "registration"): Observable<any> {
    const endpointType = type === "new" ? "onboarding" : "registration";

    // Remove the type parameter from queryString for both onboarding and registration
    let cleanQueryString = queryString;
    cleanQueryString = queryString.replace(/[?&]type=ONBOARDING/g, "").replace(/[?&]type=onboarding/g, "");
    cleanQueryString = cleanQueryString.replace(/[?&]type=REGISTERED/g, "").replace(/[?&]type=registered/g, "");

    const url = `${endpoints.partnerPage.getPartnerAnalyticsDownloadUrl}/download/${endpointType}?${cleanQueryString}`;
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.get(url, { headers, responseType: "blob" });
  }
  // downloadFile(queryString): Observable<any> {
  //     const url = `${endpoints.partnerPage.getPartnerDownloadUrl}?${queryString}`;
  //     const headers = new HttpHeaders({'Content-Type': 'application/json'});
  //     return this.http.get(url, {headers, responseType: 'blob'});
  // }

  // createPartnerOnboarding(body): Observable<any> {
  //     return this.http.post(endpoints.partnerPage.partnerOnboardingUrl, body);
  // }

  updateIdentityDocuments(formData: FormData): Observable<any> {
    return this.http.post(endpoints.partnerPage.updateIdentityDocuments, formData, this.authService.getAccessHeaders());
  }
  rejectionReason (body): Observable<any> {
    return this.http.post(endpoints.partnerPage.rejectionReasonUrl , body, this.authService.getAccessHeaders());
  }
  invitePartner(body): Observable<any> {
    return this.http.post(endpoints.partnerPage.invitePartner, body);
  }
  getPartnerList(tenantId?: string): Observable<any> {
    const url = `${endpoints.partnerPage.getPartnerUrl}?tenantId=${tenantId}`;
    return this.http.get(url, this.authService.getAccessHeaders());
  }

   partnerDocumentConfig(tenantId?: string): Observable<any> {
   
    const url = `${endpoints.partnerPage.partnerDocumentConfig}/tenant/${tenantId}`;
    return this.http.get(url, this.authService.getAccessHeaders());
  }
  updateSpocPhone(partnerId: string, body: { countryCode: string; mobileNumber: string }): Observable<any> {
    const url = `${endpoints.partnerPage.updateSpocPhoneUrl}/${partnerId}/phone`;
    return this.http.put(url, body, this.authService.getAccessHeaders());
  }

  updateSpocEmail(partnerId: string, body: { email: string }): Observable<any> {
    const url = `${endpoints.partnerPage.updateSpocEmailUrl}/${partnerId}/email`;
    return this.http.put(url, body, this.authService.getAccessHeaders());
  }

  public setRefreshPartner(data: any) {
    this.savePartnerVal.next({ result: data });
  }

  public getRefreshPartner(): Observable<any> {
    return this.savePartnerVal.asObservable();
  }
}
